import React from 'react' // eslint-disable-line no-unused-vars
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'
import "./styles.css";

const AdminConfirmationModal = ({ isModalOpen, toggleYes, toggleCancel, bodyContent }) =>
    <Modal
        className='adminConfirmation-popup-modal'
        isOpen={isModalOpen}
        backdrop
        keyboard={false}
        wrapClassName='modal-primary'
        size='lg'
    >
        <ModalBody>
            <div className='adminConfirmationModal-modal-body-content'>
                {bodyContent}
            </div>
            <div className='adminConfirmationModal-popup-button'>
                <button
                    type='button'
                    onClick={
                        toggleYes
                    }
                    className='btn btn-primary adminConfirmationModal-button btn-rounded'
                >
                    Yes
                </button>
                <button
                    type='button'
                    onClick={
                        toggleCancel
                    }
                    className='btn btn-primary adminConfirmationModal-button btn-rounded'
                >
                    Cancel
                </button>
            </div>
        </ModalBody>
    </Modal>


export default AdminConfirmationModal


// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/adminConfirmationModal.js